<script setup lang="ts">
import { ref, toRef } from "vue";
import DRDropdownItem from "@/components/UI/DRDropdownItem.vue";
import { useUpdateDrawing } from "@/stores/queries";

import { useDeviceState } from "@/stores/DeviceState";
import SearchProjectDialog from "@/components/projects/SearchProjectDialog.vue";

const props = defineProps<{
  drawingId: number;
  name?: string;
  projectId?: number;
}>();
const deviceState = useDeviceState();

const drawingId = toRef(props, "drawingId");
const { mutateAsync, isPending } = useUpdateDrawing(drawingId);

const onMoveDrawing = (projectId: number) => {
  mutateAsync(
    {
      projectId,
    },
    {
      onSuccess: () => {
        show.value = false;
      },
    }
  );
};
const show = ref(false);
const openDialog = () => {
  show.value = true;
};
</script>

<template>
  <DRDropdownItem
    :disabled="!drawingId || !deviceState.isOnline"
    @select="openDialog"
    icon="bi-folder-symlink"
    :label="$t('moveto')"
  />
  <SearchProjectDialog
    v-model="show"
    :title="$t('moveto')"
    :disabledProject="projectId"
    :loading="isPending"
    @select="onMoveDrawing($event)"
  />
</template>

<style lang="scss" scoped></style>
